export const WHATSAPP_BASE_URL = 'https://api.whatsapp.com/send/?phone=';

export enum WhatsAppMessageType {
    JOBS = 'Guten Tag, ich möchte mich gerne bei Ihnen bewerben. (Anfrage via Hyundai Händlerwebsite)',
    SERVICE = 'Guten Tag, ich habe eine Frage zum Hyundai Werkstattservice. (Anfrage via Hyundai Händlerwebsite)',
    VDP = 'Guten Tag, ich habe Interesse am folgenden Fahrzeug mit der Angebotsnummer: %vehicleId. Kontaktieren Sie mich bitte. (Anfrage via %link)',
}

export function getWhatsAppLink(whatsappNumber: string, message?: string): string | undefined {
    const number = whatsappNumber.replace(/\D/g, '');
    if (!number) return;

    const encodedMessage = message ? `&text=${encodeURIComponent(message)}` : '';

    const baseUrl = `${WHATSAPP_BASE_URL}${number}`;

    if (!encodedMessage) {
        return baseUrl;
    }
    return `${baseUrl}${encodedMessage}`;
}
